import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'
import database from './store/database'
import _ from 'lodash'
// Helpers
import MZLocationService from './services/mzlocation'
import {MZCAPI} from './helpers/http-mzcapi'
import MZLocation from './models/MZLocation'
import Hub from './events/Hub'
import MZLoyalty from './models/MZLoyalty'
import MZCoupon from './models/MZCoupon'
import store from './store'
// import LogRocket from 'logrocket'
// import createPlugin from 'logrocket-vuex'
// import {stat} from 'copy-webpack-plugin/dist/utils/promisify'
// eslint-disable-next-line no-unused-vars
let appConfigs = require(`./assets/client/${process.env.CLIENTID}/site_config.json`)

// if (_.get(appConfigs.logrocket_id)) {
//   console.log('***Loading LogRocket***')
//   LogRocket.init(appConfigs.logrocket_id)
// }

// const logrocketPlugin = createPlugin(LogRocket)

Vue.use(Vuex)

class CacheController {
  constructor ($store) {
    this.isCacheReloadInProgress = false
  }

  async reloadCache ($store) {
    if (this.isCacheReloadInProgress) {
      return
    }

    this.isCacheReloadInProgress = true

    console.log('reloading the cache 39')

    store.dispatch('entities/deleteAll')
    store.dispatch('cleanData')

    await MZLocationService.loadInitialData($store)

    this.isCacheReloadInProgress = false
  }

  async reloadCacheForGuest ($store) {
    console.log('reloading cache for guest')

    if (this.isCacheReloadInProgress) {
      return
    }

    this.isCacheReloadInProgress = true

    store.dispatch('entities/deleteAll')
    store.dispatch('cleanData')

    this.isCacheReloadInProgress = false
  }
}

export default new Vuex.Store({
  // plugins: [VuexORM.install(database), logrocketPlugin],
  plugins: [VuexORM.install(database)],
  state: {
    devMode: {
      status: false,
      fakeCordova: false
    },
    lastPermissionAsk: localStorage.getItem('lastPermissionAsk') || 0, // Default 1970-01-01
    isCordova: localStorage.getItem('isCordova') || false,
    status: '',
    lastApiCalledFailCode: '',
    location_status: '',
    token: localStorage.getItem('token') || '',
    tokenExpires: localStorage.getItem('tokenExpires') || '',
    current_page: 0,
    total_pages: -1,
    viewStateCoupons: 'list',
    viewStateLocations: 'list',
    viewStateLoyalty: 'list',
    coords: JSON.parse(localStorage.getItem('coords')) || false,
    redemptionIntentPayload: {},
    initialAjaxDone: false,
    appMode: localStorage.getItem('appMode') || 'consumer',
    userAge: localStorage.getItem('userage') || 0,
    userAgeOptOut: localStorage.getItem('opt_out_age_restricted') || 0,
    scrollPoint: {},
    profile: {},
    giftCardOnDeck: '',
    cordova: {
      ready: false,
      readyHandled: false,
      resume: false,
      resumeHandled: false,
      platform: localStorage.getItem('cordova_Platform') || false,
      permission: {
        locationDismissed: false,
        locationNeeded: localStorage.getItem('cordova_permission_LocationNeeded') || false,
        approvalNeeded: localStorage.getItem('cordova_permission_ApprovalNeeded') || false,
        backgroundDismissed: false,
        backgroundNeeded: localStorage.getItem('cordova_permission_BackgroundNeeded') || false,
        preciseDismissed: localStorage.getItem('cordova_permission_PreciseDismissed') || false,
        preciseNeeded: localStorage.getItem('cordova_permission_PreciseNeeded') || false,
        locationGoodToGo: localStorage.getItem('cordova_permission_LocationGoodToGo') || false,
        goodToGo: localStorage.getItem('cordova_permission_GoodToGo') || false,
        firedApproveBackground: localStorage.getItem('cordova_permission_FiredApproveBackground') || false,
        isFirebasePresent: localStorage.getItem('cordova_permission_IsFirebasePresent') || false,
        notificationChecked: localStorage.getItem('cordova_permission_NotificationChecked') || false,
        notificationNeeded: localStorage.getItem('cordova_permission_NotificationNeeded') || false,
        notificationAsked: localStorage.getItem('cordova_permission_NotificationAsked') || false
      }
    },
    cacheController: new CacheController(),
    storeCategories: [],
    locale: localStorage.getItem('locale') || '',
    appConfig: JSON.parse(localStorage.getItem('appConfig') || '{}')
  },
  mutations: {
    auth_request (state) {
      state.status = 'loading'
    },
    location_request (state) {
      state.location_status = 'loading-location'
    },
    location_success (state, coords) {
      state.location_status = 'success'
      state.coords = coords
    },
    location_error (state) {
      state.location_status = 'error'
    },
    auth_success (state, payload) {
      // Grab user profile and save it in the app
      localStorage.setItem('profile', JSON.stringify(payload.user))
      state.profile = payload.user
      state.appMode = 'consumer'
      localStorage.setItem('appMode', 'consumer')
      state.status = 'success'
      const token = payload.token_type + ' ' + payload.access_token
      const expires = payload.expire_time
      localStorage.setItem('token', token)
      localStorage.setItem('tokenExpires', expires)
      state.token = token
      state.tokenExpires = expires
    },
    token_refresh (state, payload) {
      console.log(payload)
      const token = payload.token_type + ' ' + payload.access_token
      const expires = payload.expire_time
      localStorage.setItem('token', token)
      localStorage.setItem('tokenExpires', expires)
      state.token = token
      state.tokenExpires = expires
    },
    user_age_changed (state, age) {
      localStorage.setItem('userage', age)
      state.userAge = age
    },
    user_age_restriction_opt_out_changed (state, status) {
      localStorage.setItem('opt_out_age_restricted', status)
      state.userAgeOptOut = status
    },
    auth_success_merchant (state, token) {
      store.dispatch('entities/deleteAll')
      state.appMode = ''
      state.status = ''
      state.token = ''
      state.current_page = 0
      state.total_pages = -1
      state.initialAjaxDone = false
      state.appMode = 'merchant'
      localStorage.setItem('appMode', 'merchant')
      state.status = 'success'
      state.token = token
    },
    auth_error (state) {
      state.status = 'error'
    },
    logout (state) {
      store.dispatch('entities/deleteAll')
      state.appMode = ''
      state.status = ''
      state.token = ''
      state.current_page = 0
      state.total_pages = -1
      state.initialAjaxDone = false
    },
    storeGiftCardOndeck (state, code) {
      state.giftCardOnDeck = code
    },
    redemptionIntentRequestPayload (state, payload) {
      state.redemptionIntentPayload = payload
    },
    initialAjaxDone (state) {
      state.initialAjaxDone = true
    },
    cleanData (state) {
      state.initialAjaxDone = false
      state.current_page = 0
      state.total_pages = -1
    },
    setScrollPoint (state, scrollPoint) {
      state.scrollPoint = scrollPoint
    },
    reloadCache (state) {
      state.cacheController.reloadCache(this)
    },
    reloadCacheGuest (state) {
      state.cacheController.reloadCacheForGuest(this)
    },
    setLastApiCallErrorCode (state, payload) {
      state.lastApiCalledFailCode = payload
    },
    setLastPermissionAsk (state, payload) {
      state.lastPermissionAsk = payload
      localStorage.setItem('lastPermissionAsk', payload)
    },
    // Cordova Specific
    setIsCordova (state, payload) {
      Hub.$emit('cordovaIsCordovaUpdated', payload)
      state.isCordova = payload
    },
    setCordovaReady (state, payload) {
      Hub.$emit('cordovaReadyUpdated', payload)
      state.cordova.ready = payload
    },
    setCordovaReadyHandled (state, payload) {
      Hub.$emit('cordovaReadyHandledUpdated', payload)
      state.cordova.readyHandled = payload
    },
    setCordovaResume (state, payload) {
      Hub.$emit('cordovaResumeUpdated', payload)
      state.cordova.resume = payload
    },
    setCordovaResumeHandled (state, payload) {
      Hub.$emit('cordovaResumeHandleUpdated', payload)
      state.cordova.resumeHandled = payload
    },
    setCordovaPlatform (state, payload) {
      Hub.$emit('cordovaPlatformUpdated', payload)
      state.cordova.platform = payload
    },
    setCordovaLocationDismissed (state, payload) {
      Hub.$emit('cordovaLocationDismissedUpdated', payload)
      state.cordova.permission.locationDismissed = payload
    },
    setCordovaPermissionLocationNeeded (state, payload) {
      Hub.$emit('cordovaPermissionLocationNeededUpdated', payload)
      state.cordova.permission.locationNeeded = payload
    },
    setCordovaPermissionApprovalNeeded (state, payload) {
      Hub.$emit('cordovaPermissionApprovalNeededUpdated', payload)
      state.cordova.permission.approvalNeeded = payload
    },
    setCordovaBackgroundDismissed (state, payload) {
      Hub.$emit('cordovaBackgroundDismissedUpdated', payload)
      state.cordova.permission.backgroundDismissed = payload
    },
    setCordovaPermissionBackgroundNeeded (state, payload) {
      Hub.$emit('cordovaPermissionBackgroundNeededUpdated', payload)
      state.cordova.permission.backgroundNeeded = payload
    },
    setCordovaPermissionPreciseDismissed (state, payload) {
      Hub.$emit('cordovaPermissionPreciseDismissedUpdated', payload)
      state.cordova.permission.preciseDismissed = payload
    },
    setCordovaPermissionPreciseNeeded (state, payload) {
      Hub.$emit('cordovaPermissionPreciseNeededUpdated', payload)
      state.cordova.permission.preciseNeeded = payload
    },
    setCordovaPermissionLocationGoodToGo (state, payload) {
      Hub.$emit('cordovaPermissionLocationGoodToGoUpdated', payload)
      state.cordova.permission.locationGoodToGo = payload
    },
    setCordovaPermissionGoodToGo (state, payload) {
      Hub.$emit('cordovaPermissionGoodToGoUpdated', payload)
      state.cordova.permission.goodToGo = payload
    },
    setCordovaPermissionFiredApproveBackground (state, payload) {
      Hub.$emit('cordovaPermissionFiredApprovedBackgroundUpdated', payload)
      localStorage.setItem('cordova_permission_FiredApproveBackground', payload)
      state.cordova.permission.firedApproveBackground = payload
    },
    setCordovaPermissionIsFirebasePresent (state, payload) {
      Hub.$emit('cordovaPermissionIsFirebasePresentUpdated', payload)
      state.cordova.permission.isFirebasePresent = payload
    },
    setCordovaPermissionNotificationChecked (state, payload) {
      Hub.$emit('cordovaPermissionNotificationCheckedUpdated', payload)
      state.cordova.permission.notificationChecked = payload
    },
    setCordovaPermissionNotificationNeeded (state, payload) {
      Hub.$emit('cordovaPermissionNotificationNeededUpdated', payload)
      state.cordova.permission.notificationNeeded = payload
    },
    setCordovaPermissionNotificationAsked (state, payload) {
      Hub.$emit('cordovaPermissionNotificationAskedUpdated', payload)
      state.cordova.permission.notificationAsked = payload
    },
    storeCategories (state, payload) {
      let tmpPayload = _.sortBy(payload, 'name')
      state.storeCategories = tmpPayload
    },
    setLocale (state, payload) {
      state.locale = payload
      localStorage.setItem('locale', payload)
    },
    setAppConfig (state, payload) {
      state.appConfig = payload
      localStorage.setItem('appConfig', JSON.stringify(payload))
    }
  },
  actions: {
    login ({commit}, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        MZCAPI.post(`/consumer/login`, user)
          .then(resp => {
            const token = resp.data.token_type + ' ' + resp.data.access_token
            localStorage.setItem('token', token)
            localStorage.setItem('tokenExpires', resp.data.expire_time)
            commit('auth_success', resp.data)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    loginMerchant ({commit}, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        MZCAPI.post(`/auth/login`, user)
          .then(resp => {
            const token = resp.data.token_type + ' ' + resp.data.access_token
            localStorage.setItem('token', token)
            commit('auth_success_merchant', token)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    checkToken ({commit}) {
      console.log('Check Token Called')
      let tokenExpires = localStorage.getItem('tokenExpires')
      let currentDate = new Date()
      let dateParts = tokenExpires.split(' ')[0].split('-')
      let timeParts = tokenExpires.split(' ')[1].split(':')
      let d = new Date(dateParts[0], --dateParts[1], dateParts[2])
      d.setHours(timeParts[0], timeParts[1], timeParts[2])
      console.log(d)

      let diff = (d.getTime() - currentDate.getTime()) / 1000
      diff /= (60 * 60)
      let hrDiff = Math.abs(Math.round(diff))
      if (hrDiff <= 60) {
        console.log('Refresh Token ******')
        return new Promise((resolve, reject) => {
          MZCAPI.post('/consumer/refresh', {},
            {
              headers: {
                Authorization: store.getters.getToken,
                MZScope: 'with-children',
                'x-mzaccount': store.getters.appConfig.api_account
              }
            })
            .then(function (response) {
              const payload = response.data
              commit('token_refresh', payload)
              resolve()
            }).catch(function (error) {
              console.log(error.status)
              reject(error)
            })
        })
      } else {
        return new Promise((resolve, reject) => {
          resolve()
        })
      }
    },
    refreshToken ({commit}) {
      return new Promise((resolve, reject) => {
        MZCAPI.post('/consumer/refresh', {},
          {
            headers: {
              Authorization: store.getters.getToken,
              MZScope: 'with-children',
              'x-mzaccount': store.getters.appConfig.api_account
            }
          })
          .then(function (response) {
            const payload = response.data
            commit('token_refresh', payload)
            resolve()
          }).catch(function (error) {
            console.log(error.status)
            reject(error)
          })
      })
    },
    register ({commit}, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        MZCAPI.post(`/consumer/registration`, user)
          .then(resp => {
            console.log(resp)
            // Login Now
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error', err)
            // localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout ({commit}) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('appMode')
        localStorage.removeItem('token')
        localStorage.removeItem('tokenExpires')
        resolve()
      })
    },
    registerFirebase ({commit, state}, token) {
      return new Promise((resolve, reject) => {
        let payload = {
          type: 'FCM',
          address: token,
          provider_service: state.appConfig.firebase_provider_service,
          meta_data: JSON.stringify(window.device),
          device_os_version: window.device.version,
          device_os: window.device.platform,
          device_model: window.device.model
        }
        MZCAPI.post(`/consumer/device`, payload, {
          headers: {
            Authorization: store.getters.getToken,
            MZScope: 'with-children'
          }
        })
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    initialAjaxDone ({commit}) {
      return new Promise((resolve, reject) => {
        commit('initialAjaxDone')
        resolve()
      })
    },
    setRedemptionIntent ({commit}, intentPayload) {
      return new Promise((resolve) => {
        commit('redemptionIntentRequestPayload', intentPayload)
        resolve()
      })
    },
    requestLocation ({ commit, state }) {
      // window.alert('Store.js - Request Location');
      return new Promise((resolve, reject) => {
        commit('location_request')

        navigator.geolocation.getCurrentPosition(position => {
          const currentPosition = position.coords
          commit('location_success', {latitude: currentPosition.latitude, longitude: currentPosition.longitude})
          Hub.$emit('location-changed', currentPosition)
          localStorage.setItem('coords', JSON.stringify(currentPosition))
          // Reload cache based on authentication status
          if (state.token) {
            commit('reloadCache')
          } else {
            commit('reloadCacheGuest')
          }
          resolve()
        }, error => {
          console.error('GEOLOCATION >> ERROR', error)
          // Use default position or attempt to use stored coordinates as a fallback
          const fallbackPosition = state.appConfig.defaultCoords || JSON.parse(localStorage.getItem('coords') || '{}')
          if (!fallbackPosition.latitude || !fallbackPosition.longitude) {
            console.error('No fallback position available')
            commit('location_error')
            reject(error)
          } else {
            console.log('Using fallback position due to geolocation error')
            commit('location_success', fallbackPosition)
            Hub.$emit('location-changed', fallbackPosition)
            localStorage.setItem('coords', JSON.stringify(fallbackPosition))
            // Assume cache needs to be reloaded as if location was obtained successfully
            commit('reloadCache')
            resolve() // Resolve the promise as handling is considered successful with fallback
          }
        })
      })
    },
    cleanData ({commit}) {
      return new Promise((resolve) => {
        commit('cleanData')
        resolve()
      })
    },
    userAgeChanged ({commit}, age) {
      return new Promise((resolve) => {
        commit('user_age_changed', age)
        resolve()
      })
    },
    userAgeOptoutChanged ({commit}, optout) {
      return new Promise((resolve) => {
        commit('user_age_restriction_opt_out_changed', optout)
        resolve()
      })
    },
    setScrollPoint ({commit}, scrollPoint) {
      return new Promise((resolve) => {
        commit('setScrollPoint', scrollPoint)
        resolve()
      })
    },
    reloadCache ({commit}) {
      return new Promise((resolve) => {
        commit('reloadCache')
        resolve()
      })
    },
    reloadCacheGuest ({commit}) {
      return new Promise((resolve) => {
        commit('reloadCacheGuest')
        resolve()
      })
    },
    storeCategories ({commit}, categories) {
      return new Promise(resolve => {
        commit('storeCategories', categories)
        resolve()
      })
    },
    userProfile ({commit}) {
      MZCAPI.get('/consumer/me',
        {
          headers: {
            Authorization: store.getters.getToken,
            MZScope: 'with-children',
            'x-mzaccount': store.getters.appConfig.api_account
          }
        })
        .then(response => {
          let dob = response.data.data.dob
          let age = 0
          // eslint-disable-next-line camelcase
          let optout = response.data.data.opt_out_age_restricted
          localStorage.setItem('opt_out_age_restricted', optout)

          if (dob) {
            let birthDate = new Date(dob)
            let ageDifMs = Date.now() - birthDate.getTime()
            let ageDate = new Date(ageDifMs) // miliseconds from epoch
            age = Math.abs(ageDate.getUTCFullYear() - 1970)
            localStorage.setItem('userage', age)
          }
          store.state.userAge = age
          store.state.userAgeOptOut = optout
          localStorage.setItem('profile', JSON.stringify(response.data.data))
          store.state.profile = response.data.data
        }).catch((error) => {
          store.commit('setLastApiCallErrorCode', error)
        })
    },
    setLocale ({commit}, locale) {
      return new Promise(resolve => {
        commit('setLocale', locale)
        resolve()
      })
    },
    setAppConfig ({commit}, payload) {
      return new Promise(resolve => {
        commit('setAppConfig', payload)
        resolve()
      })
    }
  },
  getters: {
    appConfig: state => state.appConfig,
    appMode: state => state.appMode,
    isAjaxInProgress: state => state.ajaxInProgress,
    isInitialAjaxDone: state => state.initialAjaxDone,
    getToken: state => state.token,
    getFirebaseProviderService: state => state.appConfig.firebase_provider_service,
    getTokenExpire: state => state.tokenExpires,
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    getProfile: state => state.profile,
    getGiftCardOndeck: state => state.giftCardOnDeck,
    getLastPermissionAsk: state => state.lastPermissionAsk,
    getCoords: state => {
      let coords = localStorage.getItem('coords')
      let stateCoords = state.coords

      if (coords === '' || coords === null) {
        return stateCoords
      }

      if (_.isString(coords)) {
        return JSON.parse(coords)
      } else {
        return coords
      }
    },
    getRedemptionIntentPayloadRequest: state => state.redemptionIntentPayload,
    getUserAge: state => {
      return localStorage.getItem('userage') || 0
    },
    getUserAgeOptOut: state => {
      return localStorage.getItem('opt_out_age_restricted') || 0
    },
    getAllListsFromLocal: state => {
      let _rawLocations = MZLocation.query().with('loyalty').with('coupons').with('interestCategories').get()
      let _loyaltyHold = []
      let _couponHold = []
      let _locationHold = []
      _rawLocations.forEach(function (location) {
        let _tempLocation = location
        let _tempLoyalty = _tempLocation.loyalty
        let _tempCoupons = _tempLocation.coupons
        let _tempCategory = location.interestCategories
        let _categoryName = ''
        let _categoryAgeMin = ''
        if (!_.isEmpty(_tempCategory)) {
          _categoryName = _tempCategory[0].name
          _categoryAgeMin = !isNaN(parseInt(_tempCategory[0].age_min)) ? parseInt(_tempCategory[0].age_min) : 'null'
        }

        let _locationForData = {
          id: _tempLocation.id,
          directory_list_locations: _tempLocation.directory_list_locations,
          name: _tempLocation.name,
          address1: _tempLocation.address1,
          address2: _tempLocation.address2,
          locality: _tempLocation.locality,
          region: _tempLocation.region,
          postalcode: _tempLocation.postalcode,
          image: _tempLocation.image,
          distance: _tempLocation.distance,
          categoryname: _categoryName,
          categoryagemin: _categoryAgeMin,
          latitude: _tempLocation.latitude,
          longitude: _tempLocation.longitude
        }
        _locationHold.push(_locationForData)

        if (!_.isEmpty(_tempLoyalty)) {
          _tempLoyalty.forEach(function (aLoyalty) {
            let _loyaltyForData = {
              id: aLoyalty.id,
              directory_list_loyalty: aLoyalty.directory_list_loyalty,
              name: aLoyalty.name,
              aggregator: aLoyalty.aggregator,
              user_unit_count: aLoyalty.user_unit_count,
              reward_threshold: aLoyalty.reward_threshold,
              image: aLoyalty.image,
              location_id: _tempLocation.id,
              location_name: _tempLocation.name,
              location_address1: _tempLocation.address1,
              location_address2: _tempLocation.address2,
              location_locality: _tempLocation.locality,
              location_region: _tempLocation.region,
              location_postalcode: _tempLocation.postalcode,
              location_image: _tempLocation.image,
              location_distance: _tempLocation.distance,
              location_categoryname: _categoryName,
              location_categoryagemin: _categoryAgeMin
            }
            _loyaltyHold.push(_loyaltyForData)
          })
        }

        if (!_.isEmpty(_tempCoupons)) {
          _tempCoupons.forEach(function (aCoupon) {
            let _couponForData = {
              id: aCoupon.id,
              directory_list_coupons: aCoupon.directory_list_coupons,
              name: aCoupon.name,
              image: aCoupon.image,
              has_all_redeemed: aCoupon.has_all_redeemed,
              start_date: aCoupon.start_date,
              end_date: aCoupon.end_date,
              availability: aCoupon.availability,
              location_id: _tempLocation.id,
              location_name: _tempLocation.name,
              location_address1: _tempLocation.address1,
              location_address2: _tempLocation.address2,
              location_locality: _tempLocation.locality,
              location_region: _tempLocation.region,
              location_postalcode: _tempLocation.postalcode,
              location_image: _tempLocation.image,
              location_distance: _tempLocation.distance,
              location_categoryname: _categoryName,
              location_categoryagemin: _categoryAgeMin
            }
            _couponHold.push(_couponForData)
          })
        }
      })
      let _distSortLocations = _.sortBy(_locationHold, 'distance')
      let _distSortLoyalty = _.sortBy(_loyaltyHold, 'location_distance')
      let _distSortCoupons = _.sortBy(_couponHold, 'location_distance')

      let _locationsTypeGroup = _.groupBy(_distSortLocations, 'categoryname')
      let _loyaltyTypeGroup = _.groupBy(_distSortLoyalty, 'location_categoryname')
      let _couponsTypeGroup = _.groupBy(_distSortCoupons, 'location_categoryname')

      // Filter List
      _.remove(_distSortLocations, function (n) {
        let userAge = parseInt(localStorage.getItem('userage') || 0)
        let userAgeOptOut = parseInt(localStorage.getItem('opt_out_age_restricted') || 0)
        let catAgeMin = parseInt(n.categoryagemin)
        if (catAgeMin === 0 || (userAge >= catAgeMin && !userAgeOptOut)) {
          return false
        }
        return true
      })

      _.remove(_distSortLoyalty, function (n) {
        let userAge = parseInt(localStorage.getItem('userage') || 0)
        let userAgeOptOut = parseInt(localStorage.getItem('opt_out_age_restricted') || 0)
        let catAgeMin = parseInt(n.location_categoryagemin)
        if (catAgeMin === 0 || (userAge >= catAgeMin && !userAgeOptOut)) {
          return false
        }
        return true
      })

      _.remove(_distSortCoupons, function (n) {
        let userAge = parseInt(localStorage.getItem('userage') || 0)
        let userAgeOptOut = parseInt(localStorage.getItem('opt_out_age_restricted') || 0)
        let catAgeMin = parseInt(n.location_categoryagemin)
        if (catAgeMin === 0 || (userAge >= catAgeMin && !userAgeOptOut)) {
          return false
        }
        return true
      })

      let _typeOrderedLocations = {}
      _(_locationsTypeGroup).keys().sort().each(function (key) {
        let userAge = parseInt(localStorage.getItem('userage') || 0)
        let userAgeOptOut = parseInt(localStorage.getItem('opt_out_age_restricted') || 0)
        let catAgeMin = parseInt(_locationsTypeGroup[key][0].categoryagemin)
        if (catAgeMin === 0 || (userAge >= catAgeMin && !userAgeOptOut)) {
          _typeOrderedLocations[key] = _locationsTypeGroup[key]
        }
      })

      let _typeOrderedLoyalty = {}
      _(_loyaltyTypeGroup).keys().sort().each(function (key) {
        // _typeOrderedLoyalty[key] = _loyaltyTypeGroup[key]
        let userAge = parseInt(localStorage.getItem('userage') || 0)
        let userAgeOptOut = parseInt(localStorage.getItem('opt_out_age_restricted') || 0)
        let catAgeMin = parseInt(_loyaltyTypeGroup[key][0].location_categoryagemin)
        if (catAgeMin === 0 || (userAge >= catAgeMin && !userAgeOptOut)) {
          _typeOrderedLoyalty[key] = _loyaltyTypeGroup[key]
        }
      })

      let _typeOrderedCoupons = {}
      _(_couponsTypeGroup).keys().sort().each(function (key) {
        // _typeOrderedCoupons[key] = _couponsTypeGroup[key]
        let userAge = parseInt(localStorage.getItem('userage') || 0)
        let userAgeOptOut = parseInt(localStorage.getItem('opt_out_age_restricted') || 0)
        let catAgeMin = parseInt(_couponsTypeGroup[key][0].location_categoryagemin)
        if (catAgeMin === 0 || (userAge >= catAgeMin && !userAgeOptOut)) {
          _typeOrderedCoupons[key] = _couponsTypeGroup[key]
        }
      })

      return {
        'locations':
          {'items': _distSortLocations, 'category': _typeOrderedLocations},
        'loyalty':
          {'items': _distSortLoyalty, 'category': _typeOrderedLoyalty},
        'coupons':
          {'items': _distSortCoupons, 'category': _typeOrderedCoupons}
      }
    },
    getLoyaltyFromLocal: (state) => (id) => {
      return MZLoyalty.query().find(id)
    },
    getLocationFrom: (state) => (from, id) => {
      if (from === 'region') {
        return MZLocation.query().where('beacon_region_id', id).with('coupons').get()
      } else {
        return MZLocation.query().with('coupons').find(id)
      }
    },
    getLoyalty: (state) => (id, locationId) => {
      /*
       * I was allowing the data to be pulled from cache but it was causing update issues
       */
      // let loyalty = MZLoyalty.query().find(id)
      // let location = MZLocation.query().find(locationId)

      return new Promise((resolve, reject) => {
        // We are always going to request the most up-to-date loyalty here
        // if (!loyalty || !location) {
        Promise.all([MZCAPI.get('/consumer/stores/' + locationId, {
          headers: {
            Authorization: state.token,
            MZScope: 'with-children',
            'x-mzaccount': store.getters.appConfig.api_account
          },
          params: {
            include: 'interestCategories,loyalty,coupons'
          }
        }), MZCAPI.get('/consumer/loyalty/' + id, {
          headers: {
            Authorization: state.token,
            MZScope: 'with-children',
            'x-mzaccount': store.getters.appConfig.api_account
          },
          params: {}
        })])
          .then(function ([locationCallResponse, loyaltyCallResponse]) {
            // Both requests are now complete
            let payload = {
              loyalty: loyaltyCallResponse.data.data, location: locationCallResponse.data.data
            }
            resolve(payload)
          })
        // } else {
        //   let payload = {
        //     loyalty: loyalty, location: location
        //   }
        //   resolve(payload)
        // }
      })
    },
    getCoupon: (state) => (id, locationId) => {
      let coupon = MZCoupon.query().find(id)
      if (locationId === 'online') {
        return new Promise((resolve, reject) => {
          if (!coupon) {
            Promise.all([MZCAPI.get('/consumer/coupons/' + id, {
              headers: {
                Authorization: state.token,
                MZScope: 'with-children',
                'x-mzaccount': store.getters.appConfig.api_account
              },
              params: {}
            })])
              .then(function ([couponCallResponse]) {
                // Both requests are now complete
                let payload = {
                  coupon: couponCallResponse.data.data, location: {}
                }
                resolve(payload)
              })
          } else {
            let payload = {
              coupon: coupon, location: {}
            }
            resolve(payload)
          }
        })
      } else {
        let location = MZLocation.query().find(locationId)
        return new Promise((resolve, reject) => {
          if (!coupon || !location) {
            Promise.all([MZCAPI.get('/consumer/stores/' + locationId, {
              headers: {
                Authorization: state.token,
                MZScope: 'with-children',
                'x-mzaccount': store.getters.appConfig.api_account
              },
              params: {
                include: 'interestCategories,loyalty,coupons'
              }
            }), MZCAPI.get('/consumer/coupons/' + id, {
              headers: {
                Authorization: state.token,
                MZScope: 'with-children',
                'x-mzaccount': store.getters.appConfig.api_account
              },
              params: {}
            })])
              .then(function ([locationCallResponse, couponCallResponse]) {
                // Both requests are now complete
                let payload = {
                  coupon: couponCallResponse.data.data, location: locationCallResponse.data.data
                }
                resolve(payload)
              })
          } else {
            let payload = {
              coupon: coupon, location: location
            }
            resolve(payload)
          }
        })
      }
    },
    getLocation: (state) => (id, from = 'id') => {
      // Try getting from local
      let location = null
      if (from === 'region') {
        location = MZLocation.query().where('beacon_region_id', id).with('coupons').get()
        if (!location) {
          MZCAPI.get('/consumer/stores-by-region/' + id, {
            headers: {
              Authorization: state.token,
              MZScope: 'with-children',
              'x-mzaccount': store.getters.appConfig.api_account
            },
            params: {
              include: 'interestCategories,loyalty,coupons'
            }
          })
            .then(function (response) {
              // console.log(response)
              response.data.data.coupons = response.data.data.coupons.data
              location = response.data.data
              return location
            })
        } else {
          return location
        }
      } else {
        location = MZLocation.query().with('coupons').with('loyalty').find(id)
        if (!location) {
          console.log('here444444')

          MZCAPI.get('/consumer/stores/' + id, {
            headers: {
              Authorization: state.token,
              MZScope: 'with-children',
              'x-mzaccount': store.getters.appConfig.api_account
            },
            params: {
              include: 'interestCategories,loyalty,coupons'
            }
          })
            .then(function (response) {
              console.log(response)
              response.data.data.coupons = response.data.data.coupons.data
              location = response.data.data
              return location
            })
        } else {
          return location
        }
      }
    },
    getScrollPoint: state => state.scrollPoint,
    getStoreCategories: state => state.storeCategories,
    // Development Mode Specific
    getDevModeIsDevMode: state => state.devMode.status,
    getDevModeFakeCordova: state => state.devMode.fakeCordova,
    // Cordova Specific
    getIsCordova: state => state.isCordova,
    getCordovaReady: state => state.cordova.ready,
    getCordovaReadyHandled: state => state.cordova.readyHandled,
    getCordovaResume: state => state.cordova.resume,
    getCordovaResumeHandled: state => state.cordova.resumeHandled,
    getCordovaPlatform: state => state.cordova.platform,
    getCordovaPermissionLocationDismissed: state => state.cordova.permission.locationDismissed,
    getCordovaPermissionLocationNeeded: state => state.cordova.permission.locationNeeded,
    getCordovaPermissionApprovalNeeded: state => state.cordova.permission.approvalNeeded,
    getCordovaPermissionBackgroundDismissed: state => state.cordova.permission.backgroundDismissed,
    getCordovaPermissionBackgroundNeeded: state => state.cordova.permission.backgroundNeeded,
    getCordovaPermissionPreciseDismissed: state => state.cordova.permission.preciseDismissed,
    getCordovaPermissionPreciseNeeded: state => state.cordova.permission.preciseNeeded,
    getCordovaPermissionLocationGoodToGo: state => state.cordova.permission.locationGoodToGo,
    getCordovaPermissionGoodToGo: state => state.cordova.permission.goodToGo,
    getCordovaPermissionFiredApproveBackground: state => state.cordova.permission.firedApproveBackground,
    getCordovaPermissionIsFirebasePresent: state => state.cordova.permission.isFirebasePresent,
    getCordovaPermissionNotificationChecked: state => state.cordova.permission.notificationChecked,
    getCordovaPermissionNotificationNeeded: state => state.cordova.permission.notificationNeeded,
    getCordovaPermissionNotificationAsked: state => state.cordova.permission.notificationAsked
  }
})



// WEBPACK FOOTER //
// ./src/store.js